/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react'
import { useFormPageHandler } from 'irmlib/hooks'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { TextField } from 'irmlib/components/FormControls'
import PropTypes from 'prop-types'
import { YDivider } from 'irmlib/styles'
import { useTranslation } from 'react-i18next'
import { OutlinedButton, ContainedButton } from 'irmlib/components/Controls'
import { Grid } from '@material-ui/core'

const TOTAL_BOXES = 0

const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

export const AddBoxTransmittalsModal = (props) => {
  const { handleShowModal, handleSaveBoxTransmittals, numOfBoxes } = props
  const { t } = useTranslation()
  const refLocalBusyCursor = useRef(null)
  const [open, setOpen] = React.useState(props.showModal)
  const [isErrorSave, setIsErrorSave] = React.useState(false)

  const formTemplate = [
    {
      label: 'smartCatalog.totBoxes',
      fieldKey: 'totBoxes',
      isRequired: true
    },
  ]

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  const handleClose = () => {
    setOpen(false)
    handleShowModal(false)
  }



  const saveActivity = () => {
    let totNoOfBoxes
    if (arrRefs[TOTAL_BOXES]?.current?.getValue()) {
      totNoOfBoxes = Number(arrRefs[TOTAL_BOXES]?.current?.getValue())
    } else if (numOfBoxes) {
      totNoOfBoxes = numOfBoxes
    }
    if (totNoOfBoxes > 0) {
      if (totNoOfBoxes > 50) {
        setIsErrorSave(true)
      } else {
        handleSaveBoxTransmittals(totNoOfBoxes || 0)
        setOpen(false)
        setIsErrorSave(false)
      }
    } else {
      setIsErrorSave(true)
    }
  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
        saveActivity()
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])
  const VerticalDivider = () => <YDivider height="20px" />
  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth='xs'>
        <DialogTitle>{t('smartCatalog.assetSummary')}</DialogTitle>
        <DialogContent>
          <>
            <VerticalDivider />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  // type={'number'}
                  id={'submitImages_totBoxes'}
                  inputProps={{ 
                    maxLength: 2, 
                    inputMode: 'numeric', 
                    pattern: '[0-9]*', 
                    onInput: (e) => { 
                      e.target.value = e?.target?.value?.replace(/[^0-9]/g, '') 
                    } 
                  }}
                  data={data}
                  helperText={
                    <span style={{ color: isErrorSave ? 'red' : 'black' }}>
                      {isErrorSave ? t(`${'messages.savePop'}`) : t(`${'messages.savePophelper'}`)}
                    </span>
                  }
                  fieldTemplate={formTemplate[TOTAL_BOXES]}
                  ref={arrRefs[TOTAL_BOXES]}
                  style={{ marginBottom: '20px' }}
                  value={numOfBoxes}
                  autoFocus
                />
              </Grid>
            </Grid>
          </>
        </DialogContent>
        <DialogActions sx={{ pb: 2, pr: 2 }}>
          <OutlinedButton
            style={{ width: '80px', height: '36.5px', margin: '5px' }}
            onClick={handleClose}
          >
            buttons.cancel
          </OutlinedButton>
          <ContainedButton
            style={{ width: '80px', height: '36.5px', margin: '5px' }}
            onClick={saveActivity}
          >
            buttons.save
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

AddBoxTransmittalsModal.propTypes = {
  showModal: PropTypes.bool,
  handleShowModal: PropTypes.func,
  handleSaveBoxTransmittals: PropTypes.func,
}